var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8438 14.9999C19.8438 16.4172 19.2808 17.7764 18.2786 18.7785C17.2765 19.7807 15.9173 20.3437 14.5 20.3437C13.0828 20.3437 11.7235 19.7807 10.7214 18.7785C9.71925 17.7764 9.15625 16.4172 9.15625 14.9999C9.15625 13.5827 9.71925 12.2235 10.7214 11.2213C11.7235 10.2192 13.0828 9.65617 14.5 9.65617C15.9173 9.65617 17.2765 10.2192 18.2786 11.2213C19.2808 12.2235 19.8438 13.5827 19.8438 14.9999ZM19.8438 14.9999C19.8438 16.9676 21.0396 18.5624 22.5156 18.5624C23.9917 18.5624 25.1875 16.9676 25.1875 14.9999C25.1875 12.5273 24.3301 10.1312 22.7615 8.21987C21.1929 6.30853 19.01 5.00022 16.5849 4.51786C14.1598 4.03549 11.6425 4.40893 9.46188 5.57452C7.28124 6.74012 5.57222 8.62576 4.62601 10.9102C3.6798 13.1946 3.55495 15.7364 4.27272 18.1025C4.9905 20.4686 6.5065 22.5127 8.56241 23.8864C10.6183 25.2601 13.0869 25.8784 15.5476 25.636C18.0083 25.3937 20.3089 24.3056 22.0573 22.5572M19.8438 14.9999V10.5468",
    stroke: "#02C0D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6c58c2342ed4007b24491311a1dd4669.svg";
export { ForwardRef as ReactComponent };